/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

/* eslint id-length: 0 */

var _lodashMap = require('lodash/map');

var _lodashMap2 = _interopRequireDefault(_lodashMap);

var _lodashSortBy = require('lodash/sortBy');

var _lodashSortBy2 = _interopRequireDefault(_lodashSortBy);

var _lodashFilter = require('lodash/filter');

var _lodashFilter2 = _interopRequireDefault(_lodashFilter);

var _lodashSlice = require('lodash/slice');

var _lodashSlice2 = _interopRequireDefault(_lodashSlice);

var SpecialSeriesRollup = (function (_Component) {
	_inherits(SpecialSeriesRollup, _Component);

	function SpecialSeriesRollup() {
		_classCallCheck(this, _SpecialSeriesRollup);

		_Component.apply(this, arguments);
	}

	SpecialSeriesRollup.prototype.render = function render() {
		var _classNames;

		var styles = require('./SpecialSeriesRollup.css');
		var articles = this.props.articles.results;
		var className = this.props.className;

		articles = _lodashFilter2['default'](articles, function (o) {
			return o.latestPost;
		});
		articles = _lodashSortBy2['default'](articles, function (article) {
			return article.latestPost.post_date;
		}).reverse();
		articles = _lodashSlice2['default'](articles, 0, 3);

		var baseStyles = _classnames2['default']((_classNames = {}, _classNames[className] = className, _classNames[styles.Base] = !className, _classNames));

		/* Map articles from API to <article/> elements */
		var articleRoll = _lodashMap2['default'](articles, function (article) {
			return _react2['default'].createElement(
				'article',
				{ className: styles.Article, key: article.id },
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.Link, to: article.latestPost.permalink },
					_react2['default'].createElement('h1', { className: styles.Title, dangerouslySetInnerHTML: { __html: article.name } }),
					_react2['default'].createElement(_components.MetaBar, {
						postDate: article.latestPost.post_date }),
					_react2['default'].createElement('div', { className: styles.Content, dangerouslySetInnerHTML: { __html: article.latestPost.title } })
				)
			);
		});

		return _react2['default'].createElement(
			'section',
			{ className: baseStyles },
			_react2['default'].createElement(_components.HeaderTab, { icon: 'pot', title: 'Special Series', url: '/special-series' }),
			_react2['default'].createElement(
				'div',
				{ className: styles.Articles },
				articleRoll,
				_react2['default'].createElement(
					'footer',
					{ className: styles.Footer },
					_react2['default'].createElement(
						_reactRouter.Link,
						{ className: styles.FooterLink, to: '/special-series' },
						'View all Special Series'
					)
				)
			)
		);
	};

	_createClass(SpecialSeriesRollup, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.object,
			error: _react.PropTypes.string,
			loading: _react.PropTypes.bool,
			className: _react.PropTypes.string
		},
		enumerable: true
	}]);

	var _SpecialSeriesRollup = SpecialSeriesRollup;
	SpecialSeriesRollup = _reactRedux.connect(function (state) {
		return {
			articles: state.specialSeriesRollup.data
		};
	})(SpecialSeriesRollup) || SpecialSeriesRollup;
	return SpecialSeriesRollup;
})(_react.Component);

exports['default'] = SpecialSeriesRollup;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SpecialSeriesRollup/SpecialSeriesRollup.js
 ** module id = 694
 ** module chunks = 0
 **/